export enum NoteState {
  Closed = "closed",
  Static = "static",
  Draggable = "draggable"
}
